import React, { useState, useEffect } from "react";
// import '../App.css';
import { useNavigate, useParams } from "react-router-dom";

import { useFormik } from "formik";
import { signUpSchema } from "../Schema/userIndex";

const initialValues = {
  userName: "",
  password: "",
  role: "",
  status: "",
  inputEmail: "",
  mobileNo: "",
  preAddress: "",
};

function UpdateUser() {
  const navigate = useNavigate();

  const { id } = useParams();
  const [data, setData] = useState([]);

  const [userName, setUserName] = useState("");
  // const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [preAddress, setPreAddress] = useState("");

  const [avatar, setAvatar] = useState(
    "data:image/jpeg;base64,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",
  );

  const handleUserName = (event) => {
    // console.log("On Change");

    setUserName(event.target.value);
  };

  // const handlePassword= (event)=>{
  //   // console.log("On Change");
  //   setPassword(event.target.value);
  // }

  const handleRole = (event) => {
    // console.log("On Change");
    setRole(event.target.value);
  };

  const handleStatus = (event) => {
    // console.log("On Change");
    setStatus(event.target.value);
  };

  const handleEmail = (event) => {
    // console.log("On Change");
    setInputEmail(event.target.value);
  };

  const handleMobileNo = (event) => {
    // console.log("On Change");
    setMobileNo(event.target.value);
  };

  const handlePreAddress = (event) => {
    // console.log("On Change");
    setPreAddress(event.target.value);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          `https://liftapp.infysky.in/liftapp_api/api/get_user_update/${id}`,
        );
        const result = await response.json();
        //   console.log("data:", result);
        setData(result);
        setUserName(result.us_name);
        // setPassword (result.us_password)
        setRole(result.us_role);
        setStatus(result.user_status);
        setInputEmail(result.us_email);
        setMobileNo(result.us_mobile);
        setPreAddress(result.us_address);
      } catch (error) {
        console.error("Error", error);
      }
    }

    fetchData();
  }, [id]);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,

      // validationSchema: signUpSchema,
      onSubmit: (values, action) => {
        console.log("values:", values);

        action.resetForm();
        navigate("/app/users");
      },
    });
  console.log(errors);

  const handleUserChange = (event) => {
    handleUserName(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleUserChange1 = (event) => {
    handleMobileNo(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleUserChange2 = (event) => {
    handleEmail(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  // const handleUserChange3 = (event) => {

  //   handlePassword(event); // Call the second custom onChange function
  //   handleChange(event); // Call the useFormik handleChange function
  // };

  const handleUserChange4 = (event) => {
    handleRole(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleUserChange5 = (event) => {
    handleStatus(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleUserChange6 = (event) => {
    handlePreAddress(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleUserChange7 = (event) => {
    handleFileChange(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  ///////////////////////////////////////////////////////////////////////////

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setAvatar(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  /////////////////////////////////////////////////////////////////////

  async function editUser(id) {
    // console.log(name,file,price,description)
    const formData = new FormData();
    formData.append("userName", userName);
    // formData.append("password",password)
    formData.append("role", role);
    formData.append("status", status);
    formData.append("inputEmail", inputEmail);
    formData.append("mobileNo", mobileNo);
    formData.append("preAddress", preAddress);

    try {
      let response = await fetch(
        "https://liftapp.infysky.in/liftapp_api/api/user_update/" +
          id +
          "?method=PUT",
        {
          method: "POST",
          body: formData,
        },
      );

      let data1 = await response.json(); // Parse the response body as JSON

      if (data1.msg) {
        // If the response status is within the 2xx range, it means the request was successful.
        navigate("/app/users");
        alert(data1.msg);
      } else if (data1.message) {
        alert(data1.message);
      } else {
        alert("An error occurred while saving the data.");
      }
    } catch (error) {
      console.error("Error while adding user:", error);
      alert("An error occurred while saving the data2.");
    }
  }

  ///////////////////////////////////////////////////////////////////////

  return (
    <div className="container my-2">
      <form onSubmit={handleSubmit}>
        <div className="row mb-2 my-3">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="userName"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    {" "}
                    User Name:*
                  </label>
                  <input
                    type="text"
                    name="userName"
                    defaultValue={data.us_name}
                    className="form-control a1"
                    id="userName"
                    // value={values.userName}
                    onChange={handleUserChange}
                    onBlur={handleBlur}
                  />
                  {/* {touched.userName && errors.userName ? (
                                        <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.userName}</p>
                                    ) : null} */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="mobileNo"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Mobile No
                  </label>
                  <input
                    type="text"
                    name="mobileNo"
                    defaultValue={data.us_mobile}
                    className="form-control a1"
                    id="mobileNo."
                    // value={values.mobileNo}
                    onChange={handleUserChange1}
                    onBlur={handleBlur}
                  />
                  {/* {touched.mobileNo && errors.mobileNo ? (
                                        <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.mobileNo}</p>
                                    ) : null} */}
                </div>
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="inputEmail"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Email:*
                  </label>
                  <input
                    type="email"
                    name="inputEmail"
                    defaultValue={data.us_email}
                    className="form-control a1"
                    id="inputEmail"
                    // value={values.inputEmail}
                    onChange={handleUserChange2}
                    onBlur={handleBlur}
                  />
                  {/* {touched.inputEmail && errors.inputEmail ? (
                                        <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.inputEmail}</p>
                                    ) : null} */}
                </div>
              </div>
              {/* <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="password" className='' style={{ fontSize: '12px' }}>Password:*</label>
                                    <input type="text" name="password" defaultValue={data.us_password} className="form-control a1" id="password"
                                       
                                        onChange={handleUserChange3}
                                        onBlur={handleBlur}
                                    />
                                    
                                </div>
                            </div> */}
            </div>

            <div className="row mb-1">
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="role"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Role:*
                  </label>
                  {/* <input type="text" name="role" className="form-control a1" id="role"
                                        value={values.role}
                                        onChange={handleUserChange4}
                                        onBlur={handleBlur}
                                    /> */}

                  <select
                    className="form-select border border-dark"
                    aria-label="Default select example"
                    name="role"
                    id="role"
                    // value={values.role}
                    onChange={handleUserChange4}
                    onBlur={handleBlur}
                  >
                    <option selected style={{ dispaly: "none" }}></option>
                    <option value="admin" style={{ background: "#dddddd" }}>
                      Admin
                    </option>
                    <option
                      value="office accountant"
                      style={{ background: "#dddddd" }}
                    >
                      Office Accountant
                    </option>
                    <option value="site engg" style={{ background: "#dddddd" }}>
                      Site Engg
                    </option>
                    <option
                      value="technician"
                      style={{ background: "#dddddd" }}
                    >
                      Technician
                    </option>
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="status"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Status*
                  </label>
                  <input
                    type="text"
                    name="status"
                    defaultValue={data.user_status}
                    className="form-control a1"
                    id="status"
                    // value={values.status}
                    onChange={handleUserChange5}
                    onBlur={handleBlur}
                  />
                  {/* {touched.status && errors.status ? (
                                        <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.status}</p>
                                    ) : null} */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              {/* <label htmlFor="img">Select image:</label><br /> */}
              <img
                style={{
                  width: "200px",
                  height: "200px",
                  padding: "10px",
                  borderRadius: "50%",
                }}
                className="profile-pic"
                src={avatar || values.img}
                alt="Avatar"
              />
              <br />
              <input
                type="file"
                id="img"
                name="img"
                accept="image/*"
                onChange={handleUserChange7}
              />
            </div>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-12 ">
            <div className="form-group">
              <label
                htmlFor="preAddress"
                className=""
                style={{ fontSize: "16px" }}
              >
                Address:*
              </label>
              <textarea
                className="form-control a1"
                name="preAddress"
                defaultValue={data.us_address}
                id="preAddress"
                rows="5"
                // value={values.preAddress}
                onChange={handleUserChange6}
                onBlur={handleBlur}
              ></textarea>
              {/* {touched.preAddress && errors.preAddress ? (
                                <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.preAddress}</p>
                            ) : null} */}
            </div>
          </div>
        </div>

        <div className="container ">
          <div className="row  ">
            <div className="col-12 ">
              <div className="form-group">
                <button
                  onClick={() => editUser(data.us_id)}
                  className="btn btn-primary btn-lg float-right "
                  type="submit"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default UpdateUser;
